import { Component, OnInit } from '@angular/core';
import { ClientProductModel } from 'src/app/shared/models/client-products.model';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CryptoVaultService } from 'src/app/shared/services/external/crypto-vault/crypto-vault.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { BUSINESS_CONST } from '../../../shared/constants/business.constants';
import { CheckboxModel } from '../../../shared/models/common.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { RequestService } from '../../../shared/services/request/request-onboarding.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  EVENT as EVENT_FA_LD,
  PAGEVIEW as PAGEVIEW_FA_LD,
  CHANNEL as CHANNEL_FA_LD,
  COUNTRY as COUNTRY_FA_LD,
  BUSINNESS as BUSINNESS_FA_LD,
  ENVIRONMENT as ENVIRONMENT_FA_LD,
  FAMILY as FAMILY_FA_LD,
  SUBFAMILY as SUBFAMILY_FA_LD,
  PRODUCT as PRODUCT_FA_LD,
} from 'src/app/shared/constants/dali-fa-ld.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-account-selection',
  templateUrl: './account-selection.component.html',
  styleUrls: ['./account-selection.component.scss'],
})
export class AccountSelectionComponent implements OnInit {

  options: [any];
  options1: [any];
  selectedAccountU: ClientProductModel;
  validButton = true;
  checkboxTerms: CheckboxModel;
  number: any;
  transaction_id: any;
  showCheck = false;
  copie: any;
  getProductFlow: string;
  productType: string;
  hasOrdAndCrp: boolean;
  isFirmlyApproved: boolean;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private captureService: CaptureService,
    private validationHelperService: ValidationHelperService,
    private requestService: RequestService,
    private cipherService: CryptoVaultService,
    private firmlyApprovedService: FirmlyApprovedService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private daliService: DaliService,
    private taggingService: TaggingService,
  ) {
    this.headerService.show(true, true, true);
  }

  ngOnInit() {
    this.sendTagging('init');
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendAccountSelectionPageLoad();
    }
    this.validateOrdAndCrp();
    const getCurrentStep = this.navigationService.getCurrentStep().key;
    this.productType = this.abreCuentasService.getproductSelected().product_type;
    if (getCurrentStep === 'account-selection' && this.abreCuentasService.getproductSelected().product_type === 'multi') {
      this.abreCuentasService.setAssociateCopyRevolving(false);
    }
    if (this.abreCuentasService.getproductSelected().product_type === 'multi') {
      this.getProductFlow = getCurrentStep === 'account-selection' ? 'default' : BUSINESS_CONST.PRODUCT_TYPE_REVOLVING;
    } else {
      this.getProductFlow = this.productType !== BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ? 'default' : BUSINESS_CONST.PRODUCT_TYPE_REVOLVING;
    }
    this.isFirmlyApproved = !this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme';
    if (this.isFirmlyApproved && this.hasOrdAndCrp) {
      this.copie = this.getCopie('firmly');
    } else {
      this.copie = this.getCopie(this.productType === 'multi' ? this.getProductFlow : this.productType);
    }
    this.options = this.abreCuentasService.getListClientProduct();
    const selectedAccount = this.getProductFlow === 'default' ? this.abreCuentasService.getcreateProductSelected() :
      this.abreCuentasService.getAssociateRevolving();
    if (selectedAccount) {
      this.selectedAccountU = selectedAccount;
    } else {
      this.selectedAccountU = { account_id: '', account_type: '', account_subtype: '' };
    }
    this.checkboxTerms = {
      id: '',
      label: 'Activar el débito automático de mi crédito.',
      checked: false,
      value: '',
    };
  }

  getCopie(product_type: string) {
    let data = {
      revolvingCredit: {
        title: this.copyService.copies.account_selection.title_revolving_credit,
        label: this.copyService.copies.account_selection.account_selection_label,
      },
      firmly: {
        title_1: this.copyService.copies.account_selection.title_free_investment_multi_1,
        title_2: this.copyService.copies.account_selection.title_free_investment_multi_2,
        label: this.copyService.copies.account_selection.account_selection_free_investment_label,
        title_card_multi: this.copyService.copies.account_selection.title_card_multi,
      },
      default: {
        title: this.copyService.copies.account_selection.title_free_investment,
        label: this.copyService.copies.account_selection.account_selection_free_investment_label,
      },
    };
    return data[product_type] ? data[product_type] : data['default'];
  }

  /**
   * Summary Go to next Step
   */
  next() {
    this.sendTagging('next', 'center', '2');
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendAcceptButtonEvent();
    }
    this.disbursementLoan();
    this.regularDisbursement();
    if (this.abreCuentasService.viewOptionMultiProduct) {
      this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
    } else {
      this.navigationService.nextStep('200');
    }
  }

  disbursementLoan() {
    if (this.abreCuentasService.haveLoan && this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.ITAU) {
      this.abreCuentasService.getDisbursementInfo().find(
        element => element.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN,
      ).refund[0].account.account_id = this.selectedAccountU.account_id;
      this.abreCuentasService.getDisbursementInfo().find(
        element => element.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN,
      ).refund[0].account.account_type = this.selectedAccountU.account_type;
    }
  }

  regularDisbursement() {
    if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
      this.abreCuentasService.getDisbursementInfo().find(
        element => element.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE
                  || element.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING,
        ).refund[0].account.account_id = this.selectedAccountU.account_id;

      if (this.abreCuentasService.viewOptionMultiProduct) {
        const creditCard = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)[0];
        if (creditCard) {
          return;
        }
        const freeInvestment = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_FREE)[0];
        const revolvingCredit = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)[0];
        const productsFirmlyApproved: any[] = [];

        if (freeInvestment) {
          productsFirmlyApproved.push(freeInvestment);
        }
        if (revolvingCredit) {
          productsFirmlyApproved.push(revolvingCredit);
        }
        this.abreCuentasService.getPcoModel().granted_product_multi = productsFirmlyApproved;
      }
    }
  }

  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOption(event) {
    console.log('------Ingreso por account-selection------');
    if (event.value) {
      this.selectedAccountU.account_id = event.value.product_number;
      this.selectedAccountU.account_type = event.value.product_type;
      this.selectedAccountU.account_subtype = event.value.product_sub_type;
      if (!this.firmlyApprovedService.isEmpty()
      && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
      && this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)
      && this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.FREE_INVESTMENT)) {
        this.abreCuentasService.setAssociateRevolving(this.selectedAccountU);
        this.abreCuentasService.setAssociateCopyRevolving(true);
        this.abreCuentasService.setcreateProductSelected(this.selectedAccountU);
      } else if (this.getProductFlow === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
        this.abreCuentasService.setAssociateRevolving(this.selectedAccountU);
        this.abreCuentasService.setAssociateCopyRevolving(true);
      } else {
        this.abreCuentasService.setcreateProductSelected(this.selectedAccountU);
      }
      this.validButton = false;
    } else {
      this.selectedAccountU = { account_id: '', account_type: '', account_subtype: '' };
      this.validButton = true;
    }
  }

  validateOrdAndCrp() {
    let productCount = 0;
    this.abreCuentasService.getProductsSelects().forEach((product: any) => {
      if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
          product.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
        productCount++;
      }
    });
    this.hasOrdAndCrp = productCount >= 2;
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendAccountSelectionPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const productsType = {
      ORD: 'LD',
      TCR: 'TC',
    };
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA_LD.pv10pageName.path,
        value: `${isApp ? CHANNEL_FA_LD.superapp : CHANNEL_FA_LD.homeBanking}:${COUNTRY_FA_LD.co}:${BUSINNESS_FA_LD.pf}:${ENVIRONMENT_FA_LD.loggeado}:${FAMILY_FA_LD.services}:${SUBFAMILY_FA_LD.request}:${PRODUCT_FA_LD.request}:${PAGEVIEW_FA_LD.pv10pageName.value}`,
      },
      {
        path: PAGEVIEW_FA_LD.pv10pageFamily.path,
        value: PAGEVIEW_FA_LD.pv10pageFamily.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv10subFamily.path,
        value: PAGEVIEW_FA_LD.pv10subFamily.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv10pageAction.path,
        value: PAGEVIEW_FA_LD.pv10pageAction.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv10pageid.path,
        value: AccountSelectionComponent.name,
      },
      {
        path: PAGEVIEW_FA_LD.pv10transactionName.path,
        value: `${PAGEVIEW_FA_LD.pv1transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA_LD.pv10transactionTransactionStep.path,
        value: PAGEVIEW_FA_LD.pv10transactionTransactionStep.value,
      },
    ];
    this.taggingService.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* -------------- Taggeo - Events ------------- */
  sendBackButtonEvent(): void {
    this.sendTagging('prev', 'center' , '1');
    if (!this.taggingService.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_LD.pv10E1setData.pv10E1transactionTransactionStep.path,
        value: EVENT_FA_LD.pv10E1setData.pv10E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv10E1setData.pv10E1transactionName.path,
        value: `${PAGEVIEW_FA_LD.pv1transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv10E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendAcceptButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv10E2setData.pv10E2transactionTransactionStep.path,
        value: EVENT_FA_LD.pv10E2setData.pv10E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv10E2setData.pv10E2transactionName.path,
        value: `${PAGEVIEW_FA_LD.pv1transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv10E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendTagging(value: any, position?: string, event?: string) {
    const page = '15';
    const extras = {
      pageValue: 'AccountSelection',
    };
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }
}
